module.exports = __webpack_public_path__ + "img/a2f73f5.png";